import { defineAsyncComponent } from "vue";

const FieldsFormDisplay = defineAsyncComponent(() => import("./FieldsFormDisplay.vue"));

export { FieldsFormDisplay };
